export default "__VITE_ASSET__baeb8066__"